import type { ElibooApp } from "@eliboo/api-models";

import { inject } from "@angular/core";
import { type ActivatedRouteSnapshot, RedirectCommand, type ResolveFn, Router, type RouterStateSnapshot } from "@angular/router";
import { catchError, of } from "rxjs";

import { InvoiceService, TaxUserService } from "../service";

export const invoiceResolver: ResolveFn<ElibooApp.ChannelOperatorConfigDTO> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  console.log('invoiceResolver', route, state);

  const invoiceService = inject(InvoiceService);
  const taxUserService = inject(TaxUserService);
  const router = inject(Router);
  console.log("associationId", taxUserService.channelOperatorInfoId());
  if (!taxUserService.channelOperatorInfoId()) {
    return of(new RedirectCommand(router.parseUrl("/result?msg=该平台数据异常,请联系管理员")))
  }
  if (!taxUserService.associationId()) return of(new RedirectCommand(router.parseUrl("/result?msg=该平台数据异常,请联系管理员")))
  return invoiceService.getChannelOperatorConfig(taxUserService.associationId()!.toString()).pipe(
    catchError((err) => {
      return of({})
    })
  );
};
